export default "__VITE_ASSET__BrxuD$Rt__"